import { node, object } from 'prop-types';
import React, { createContext, useState } from 'react';

const AppContext = createContext();

// The initial state of the application context
// If the window is defined, then the context will be found in __APP_CONTEXT__
// If not, then it should be an empty object
const INITIAL_STATE = typeof window !== 'undefined' ? window.__APP_CONTEXT__ : {}; // eslint-disable-line no-undef

// The app context provider component
const AppContextProvider = ({ defaultAppContext, children }) => {
    // defaultAppContext is returned by the server on the initial render
    const [appContext, setAppContext] = useState(defaultAppContext || INITIAL_STATE);
    return (<AppContext.Provider
        value={{ appContext,
            setAppContext }}>
        {children}
    </AppContext.Provider>);
};

AppContextProvider.propTypes = {
    defaultAppContext: object,
    children: node,
};

// The app context consumer
const AppContextConsumer = AppContext.Consumer;

export { AppContext, AppContextProvider, AppContextConsumer };
export default AppContext;